import { render, staticRenderFns } from "./SalesReturnReport.vue?vue&type=template&id=e4671a32&"
import script from "./SalesReturnReport.vue?vue&type=script&lang=js&"
export * from "./SalesReturnReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SalesReturnReport.vue"
export default component.exports